export default __webpack_public_path__ + "static/media/070_boost.first.b31992c7.webp";